import {FC, useEffect, useState} from 'react'
import {
  AllocateCreditSubClientMode,
  AllocateCreditSubClientParam,
  CampType,
} from '../../../../../services/cellcast.v2.types'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useAllocateCreditSubClientMutation} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {useDispatch} from 'react-redux'
import {fetchAsyncUserDetails} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {FixedTwoDecimal} from '../../../../Utils/_helpers/string'

export type WriteCreditProps = {
  show: boolean
  mode: AllocateCreditSubClientMode
  handleClose: () => void
  callbackFn: () => void
  userId: string
  userName: string
  smsCredit: number
  mmsCredit: number
}

const WriteCredit: FC<WriteCreditProps> = (props) => {
  const {show, mode, userId, userName, smsCredit, mmsCredit, callbackFn, handleClose} = props

  const dispatch = useDispatch()

  const [smsLocalCredit, setSmsCredit] = useState(0)
  const [mmsLocalCredit, setMMsCredit] = useState(0)

  // local state
  const [params, setParams] = useState<AllocateCreditSubClientParam>({
    id: userId,
    data: {
      amount: 0,
      campType: CampType.sms,
      mode: mode,
    },
  })
  const [errorMessage, setErrorMessage] = useState('')

  const [allocateCredit, {isLoading: allocateLoading}] = useAllocateCreditSubClientMutation()

  const handleInputChange = (amountInput: string) => {
    setErrorMessage('')
    const amount = parseFloat(amountInput) || 0
    const tmpData = {...params.data, amount: amount}
    setParams({...params, data: tmpData})

    const newSms = smsCredit - amount
    const newMms = mmsCredit - amount

    if (params.data.campType === CampType.sms && newSms < 0) {
      setErrorMessage('sms balance is not enough')
    }
    if (params.data.campType === CampType.mms && newMms < 0) {
      setErrorMessage('sms balance is not enough')
    }
    setSmsCredit(newSms)
    setMMsCredit(newMms)
  }

  const handleSubmit = () => {
    if (params.data.amount === 0 || params.id === '') {
      return
    }

    allocateCredit(params)
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          if (callbackFn) {
            callbackFn()
          }
          setErrorMessage('')
          dispatch(fetchAsyncUserDetails())
        } else if ('error' in res) {
          const errObj = res.error as any
          setErrorMessage(errObj.data.message)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }

  useEffect(() => {
    const tmpData = {...params.data, mode: mode}
    setParams({...params, data: tmpData})
  }, [mode])

  useEffect(() => {
    setSmsCredit(smsCredit)
    setMMsCredit(mmsCredit)
  }, [smsCredit, mmsCredit])

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px'
      className='vh-100'
      show={show}
      onHide={handleClose}
    >
      <div className='modal-header border-bottom'>
        <h2>{mode === AllocateCreditSubClientMode.add ? 'Add' : 'Remove'} credits</h2>
        <div className='btn btn-icon btn-sm' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>
      <div className='modal-body pl-10 pr-10'>
        <div className='row mb-2'>
          <div className='border-end pe-15'>
            <div className='d-flex flex-column justify-content-center align-items-center w-100 mb-5'>
              <h3>
                {mode === AllocateCreditSubClientMode.add ? `Your Balance` : 'User Balance'}{' '}
                {`(${userName})`}
              </h3>
              <h1 style={{fontSize: 40}}>
                {params.data.campType === CampType.sms
                  ? FixedTwoDecimal(smsLocalCredit)
                  : FixedTwoDecimal(mmsLocalCredit)}
              </h1>
            </div>
            <div className='d-flex justify-content-center align-items-center gap-2'>
              <div>
                <input
                  type='radio'
                  className='btn-check'
                  name='sms'
                  checked={params.data.campType === CampType.sms}
                  id='quick_sms_radio2'
                  onClick={() => {
                    const tmpData = {...params.data, campType: CampType.sms}
                    setParams({...params, data: tmpData})
                  }}
                />
                <label className='btn btn-light-info py-2 px-5' htmlFor='quick_sms_radio2'>
                  <span className='fw-500 fs-2'>SMS</span>
                </label>
              </div>
              <div>
                <input
                  type='radio'
                  className='btn-check'
                  name='mms'
                  checked={params.data.campType === CampType.mms}
                  id='quick_mms_radio2'
                  onClick={() => {
                    const tmpData = {...params.data, campType: CampType.mms}
                    setParams({...params, data: tmpData})
                  }}
                />
                <label
                  className='btn btn-active-info btn-light-info py-2 px-5'
                  htmlFor='quick_mms_radio2'
                >
                  <span className='fw-500 fs-2'>MMS</span>
                </label>
              </div>
            </div>

            <div className='mt-7'>
              <label className=' col-form-label fw-normal fs-6'>
                How many messages are you{' '}
                {mode === AllocateCreditSubClientMode.add ? 'send' : 'take'} ?
              </label>
              <input
                onChange={(e) => handleInputChange(e.target.value)}
                name='Type'
                type='text'
                className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
              />
              {errorMessage && errorMessage.length > 0 && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'>{errorMessage}</div>
                </div>
              )}
            </div>
          </div>
          <div className='d-flex flex-center mt-20'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-light text-hover-white rounded btn-active-primary me-3 w-100px p-3 fw-500 me-2'
              >
                Discard
              </button>
            </div>

            <button
              disabled={params.data.amount === 0 || errorMessage !== ''}
              type='submit'
              className='btn btn-light btn-primary fw-500 rounded w-100px p-3 border border-primary'
              onClick={() => handleSubmit()}
            >
              <span className='indicator-label'>{allocateLoading ? 'Processing' : 'Submit'}</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default WriteCredit
